module.exports = __webpack_public_path__ + "images/emoji/arrow_forward.0c25f6f700303a06a4e8.png";